import { DeleteOutlined } from '@ant-design/icons';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import ConnectionModel from '@mm/state/model/ConnectionModel';
import TagModel from '@mm/state/model/TagModel';
import { AudienceSimpleSelect } from '@mm/stateful-components';
import { Switch } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { TagsSelector } from '../TagsSelector/TagsSelector';
import styles from './BrazeIntegrations.module.css';

type Props = {
  update: (params: Partial<ConnectionModel>) => void;
  remove?: () => void;
  connection: Partial<ConnectionModel>;
  withAudiences: boolean;
  canDelete: boolean;
  audiences: AudiencesModel[];
  activeFbPageId: number;
  availableTags: TagModel[];
};

export const BrazeConnectionEditor = ({
  connection,
  update,
  remove,
  canDelete,
  withAudiences,
  audiences,
  activeFbPageId,
  availableTags,
}: Props) => (
  <>
    {withAudiences && (
      <div className={styles.gridColumn}>
        <AudienceSimpleSelect
          options={audiences}
          className={styles.audiencesSelect}
          selectedAudienceId={connection?.audienceId || undefined}
          onChange={audienceId => update({ audienceId })}
        />
      </div>
    )}
    <div className={styles.gridColumn}>
      <TagsSelector
        onChange={tag => {
          if (tag) {
            update({
              tags: [
                ...(connection.tags || []),
                { name: tag.name, sentAs: tag.name },
              ],
            });
          }
        }}
        onTagRemove={tag => {
          if (tag) {
            const tagIndex = (connection.tags || []).findIndex(
              connTag => connTag.name === tag.name,
            );
            if (tagIndex >= 0) {
              update({
                tags: [
                  ...(connection.tags || []).slice(0, tagIndex),
                  ...(connection.tags || []).slice(tagIndex + 1),
                ],
              });
            }
          }
        }}
        fbPageId={activeFbPageId}
        availableTags={availableTags}
        tags={(connection.tags || []).map(tag => ({
          name: tag.name,
          unsaved: false,
          kind: 'regular',
        }))}
      />
    </div>
    <div className={classNames(styles.gridColumn, styles.actionsColumn)}>
      <Switch
        defaultChecked={connection?.active}
        checkedChildren="Sync on"
        unCheckedChildren="Sync off"
        className={styles.switch}
        onChange={ok => update({ active: ok })}
        disabled={!connection?.id}
      />
      {canDelete && <DeleteOutlined onClick={() => remove?.()} />}
    </div>
  </>
);
